import { Content } from 'app/content/model/model';
import { Dialog } from 'app/dialogs/model/model';

export interface UserRole {
  id: number;
  name: string;
}

export interface UserDevice {
  token: string;
  type: string;
  name: string;
}

export interface UserBadge {
  _id: string;
  badge: string;
  createdAt: string;
  new: boolean;
}

export interface Settings {
  timesReflectionMorningAlert: string;
  timesReflectionMorningDay?: Array<boolean>,
  timesReflectionEveningStart: string;
  timesReflectionEveningAlert: string;
  timesReflectionEveningDay?: Array<boolean>,
  timesReflectionResilienceStart: string;
  timesReflectionResilienceAlert: string;
  timesReflectionResilienceDay?: Array<boolean>,
  timesReflectionNightStart: string;
  timesReflectionNightAlert: string;
  timesReflectionNightDay?: Array<boolean>,
  timesDialogsFirst: string;
  timesDialogsSecond: string;
  leading?: Leading;
  showLeaderContent: boolean;
}

export interface UserProfile {
  _id: string;
  email: string;
  firstname: string;
  lastname: string;
  roles: Array<UserRole>;
  devices: Array<UserDevice>;
  active: boolean;
  companyId: number;
  app: string;
  voucher: string;
  diffFromUTC: string;
  badges: Array<UserBadge>;
  settings: Settings;
  company: {name: string, leaderLinking?: number, episodes?: number};
  groups: Array<any>;
  contents?: Array<UserContent>;
  podcastLastViewedAt?: Date;
  createdAt?: Date;
}

export interface Leading {
  leading: boolean;
  years: number;
  employees: string;
  level: string;
  expectation: string;
  goal: string;
  topics: Array<string>;
  leader?: string;
}

export interface UserContent {
  _id: string;
  content: string;
  new: boolean;
  state: number; // 0 .. unstartet, 1 .. blocked wg. precond, 2 -- blocked wg. notparallel, 3 .. purchasable, 5 .. aktiv, 6 .. pausing, 9 .. done
  startDate?: Date; // the date the user aktivated the content
  doneDate?: Date;
  contentFull?: Content;
  baseDate?: Date;
  purchasedAt: Date;
  suggest?: number;
  dialogs?: Array<Dialog>;
  curContentPos?: number; // which dialog has to be answer next, starting with 0; -1 .. not relevant (done contents e.g.)
  regularLength?: number; // legth of content without final "Refresh" dialogs
}
